import * as React from 'react';

export interface UseBhanzuBuddyUserInteractionProps {
  hasUserInteracted: boolean;
  setHasUserInteracted: (value: boolean) => void;
}

export const useBhanzuBuddyUserInteraction = ({
  hasUserInteracted,
  setHasUserInteracted,
}: UseBhanzuBuddyUserInteractionProps) => {
  React.useEffect(() => {
    const handleUserInteraction = () => {
      if (!hasUserInteracted) {
        setHasUserInteracted(true);
      }
    };
    const events = ['click', 'keydown', 'scroll', 'touchstart'];
    for (const event of events) {
      document.addEventListener(event, handleUserInteraction, {
        passive: true,
      });
    }
    return () => {
      for (const event of events) {
        document.removeEventListener(event, handleUserInteraction);
      }
    };
  }, [hasUserInteracted, setHasUserInteracted]);
};
